var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Col, Row } from "react-bootstrap";
// components
import SavedProductMutualFund from "./MutualFund";
import SearchBookmark from "./SearchBookmark";
// shared-library
import Common_Shimmer from "@frameworks/shared-library/components/common_shimmer";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import BookmarkApp from "@frameworks/pmsjourney/app/bookmark/BookmarkApp";
import SaveProductOtc from "@frameworks/NCD/pages/SaveProduct";
var AllTab = function (_a) {
    var viewAllClick = _a.viewAllClick, updateCount = _a.updateCount;
    var _b = __read(React.useState(undefined), 2), searchValue = _b[0], setSearchValue = _b[1];
    var renderHeader = function (data, loader, label) {
        return loader ? (React.createElement(Row, null,
            React.createElement(Col, { md: 3 },
                React.createElement(Common_Shimmer, { number: 1 })))) : (React.createElement("label", { className: "DMSansNormal_20_400 " }, "".concat(label, " ").concat(data ? "(".concat(data, ")") : "(0)")));
    };
    return (React.createElement("div", { className: "primary-saved-products-all-tabs-container" },
        React.createElement(SearchBookmark, { searchValue: searchValue, setSearchValue: setSearchValue }),
        React.createElement(SavedProductMutualFund, { viewAll: false, viewAllClick: viewAllClick, showDataPerPage: 5, searchText: searchValue, header: function (data, loader) {
                updateCount("mf", data);
                return renderHeader(data, loader, "Mutual Fund");
            } }),
        React.createElement(BookmarkApp, { viewAll: true, showDataPerPage: 5, viewAllClickPath: "pms", viewAllClick: viewAllClick, subCategoryId: Number(ESubProductIds.PMS), isAll: false, header: function (data, loader) {
                updateCount("pms", data);
                return renderHeader(data, loader, "PMS");
            }, setTotalDataRecord: function (value) {
                updateCount("pms", value);
            }, searchText: searchValue }),
        React.createElement(BookmarkApp, { viewAll: true, showDataPerPage: 5, viewAllClick: viewAllClick, viewAllClickPath: "aif", subCategoryId: Number(ESubProductIds.AIF), isAll: false, header: function (data, loader) {
                updateCount("aif", data);
                return renderHeader(data, loader, "AIF");
            }, setTotalDataRecord: function (value) { return updateCount("aif", value); }, searchText: searchValue }),
        React.createElement(SaveProductOtc, { subCategoryId: String(ESubProductIds.StructuredProducts), isSaveProduct: true, header: function (totalItems) {
                updateCount("sp", totalItems);
                return renderHeader(totalItems, false, "Structured Products (SP)");
            }, allTabPage: true, viewAll: true, showDataPerPage: 5, viewAllClick: viewAllClick, viewAllClickPath: "sp", searchText: searchValue }),
        React.createElement(SaveProductOtc, { subCategoryId: String(ESubProductIds.NCD), isSaveProduct: true, header: function (totalItems) {
                updateCount("ncd", totalItems);
                return renderHeader(totalItems, false, "Non Convertible Debentures (NCD)");
            }, showDataPerPage: 5, viewAllClick: viewAllClick, viewAllClickPath: "ncd", allTabPage: true, viewAll: true, searchText: searchValue }),
        React.createElement(SaveProductOtc, { subCategoryId: String(ESubProductIds.Bonds), isSaveProduct: true, header: function (totalItems) {
                updateCount("bonds", totalItems);
                return renderHeader(totalItems, false, "Bonds");
            }, allTabPage: true, showDataPerPage: 5, viewAllClick: viewAllClick, viewAllClickPath: "bonds", viewAll: true, searchText: searchValue }),
        React.createElement(SaveProductOtc, { subCategoryId: String(ESubProductIds.UnlistedShares), isSaveProduct: true, header: function (totalItems) {
                updateCount("unlistedShares", totalItems);
                return renderHeader(totalItems, false, "Unlisted Shares");
            }, allTabPage: true, showDataPerPage: 5, viewAllClick: viewAllClick, viewAllClickPath: "unlistedShares", viewAll: true, searchText: searchValue })));
};
export default AllTab;
